/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionConfigDate
 */
export interface BidirectionalActionConfigDate {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    required: boolean;
    /**
     * 
     */
    disable_past?: boolean;
}

/**
 * Check if a given object implements the BidirectionalActionConfigDate interface.
 */
export function instanceOfBidirectionalActionConfigDate(value: object): value is BidirectionalActionConfigDate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function BidirectionalActionConfigDateFromJSON(json: any): BidirectionalActionConfigDate {
    return BidirectionalActionConfigDateFromJSONTyped(json, false);
}

export function BidirectionalActionConfigDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigDate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'required': json['required'],
        'disable_past': json['disable_past'] == null ? undefined : json['disable_past'],
    };
}

export function BidirectionalActionConfigDateToJSON(json: any): BidirectionalActionConfigDate {
    return BidirectionalActionConfigDateToJSONTyped(json, false);
}

export function BidirectionalActionConfigDateToJSONTyped(value?: BidirectionalActionConfigDate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'required': value['required'],
        'disable_past': value['disable_past'],
    };
}

